import { render, staticRenderFns } from "./supplierfrm.vue?vue&type=template&id=aa5160ae"
import script from "./supplierfrm.vue?vue&type=script&lang=js"
export * from "./supplierfrm.vue?vue&type=script&lang=js"
import style0 from "./supplierfrm.vue?vue&type=style&index=0&id=aa5160ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports